export default "__VITE_ASSET__cab6e327__"